import curry from "lodash-es/curry";
import flowRight from "lodash-es/flowRight";

// Only way we could find to keep all the lodash functions together in one, tree-shaken file.
export default {
    curry,
    flowRight,
}